import axios from "axios";

export default {
    state: () => ({
    }),
    mutations: {},
    getters: {},
    actions:{
        loadCityList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/city", {headers})
                .then((response) => {
                    return response.data;
                })
        },
        updateCity(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/city", request,{headers})
                .then((response) => {
                    return response.data;
                })

        },
        createCity(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/city", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deleteCity(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/city/"+request.id,{headers})
                .then((response) => {
                    return response.data;
                })
        },
    }
}